// extracted by mini-css-extract-plugin
export default {"skeletonWrapper":"ChatMessageSkeleton_skeletonWrapper__uqKjy"};